import React, { Component, Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import { remove, uniqBy, findIndex } from "lodash";
import { MAX_WIDTH_SP, TEXT_CANCEL } from "../../const";

export default class ModalListDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listDesign: JSON.parse(localStorage.getItem("products")).reverse() || [],
      isShowDialogConfirmDelete: false,
      idDel: null
    };
  }

  handleGetHeight() {
    let heightWin = window.innerHeight;

    return heightWin - 200;
  }

  handleDeleteDesign() {
    let { listDesign, idDel } = this.state;
    let tmpListDesign = listDesign;

    if (idDel === null) {
      return;
    }

    this.handleToggleDialogDelete();
    remove(tmpListDesign, item => {
      return item.id === idDel;
    });
    this.setState({
      listDesign: tmpListDesign
    });
    localStorage.setItem("products", JSON.stringify(tmpListDesign));
  }

  handleToggleDialogDelete(id) {
    let { isShowDialogConfirmDelete } = this.state;

    if (typeof id !== "undefined") {
      this.setState({
        idDel: id,
        isShowDialogConfirmDelete: !isShowDialogConfirmDelete
      });

      return;
    }

    this.setState({
      idDel: null,
      isShowDialogConfirmDelete: !isShowDialogConfirmDelete
    });
  }

  handleEditDesign(design) {
    let { handleCloseDialog, handleUpdateDesign, handleUpdateState } = this.props;
    let orderMadeId = null
    if(design.hasOwnProperty("orderMadeId") && design.orderMadeId != null){
      orderMadeId = design.orderMadeId;
    }
    //Reset orderMadeId null
    handleUpdateState("paramUrl", {
      orderMadeId: orderMadeId,
    });
    handleUpdateState("isShowHamburger", false);
    handleUpdateDesign(design);
    handleCloseDialog("isShowModalListDesign");
  }

  handleRenderListMaterial(design) {
    let { productList } = this.props;
    let result = [];
    let uniqItems = uniqBy(design.items, "productID");

    uniqItems.map((item, index) => {
      let idItem = findIndex(productList, obj => obj.id === item.productID);

      if (idItem !== -1) {
        if (uniqItems.length === index + 1) {
          result = result + `${productList[idItem].name}`;
        } else {
          result = result + `${productList[idItem].name} / `;
        }
      }
    });

    return result;
  }

  handleRenderTypeName(design) {
    let { ringTypeList } = this.props;
    let idItem = findIndex(ringTypeList, obj => obj.id === design.ringTypeId);

    if (idItem !== -1) {
      return ringTypeList[idItem].name;
    }

    return "";
  }

  render() {
    let { listDesign, isShowDialogConfirmDelete } = this.state;
    let {
      handleCloseDialog,
      isShowModalListDesign,
      getWidthBrowser
    } = this.props;
    return (
      <Fragment>
        <Modal
          show={isShowModalListDesign}
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName={`modal_fullW modal_custom  ${
            getWidthBrowser() >= MAX_WIDTH_SP ? "" : "modal_fullW_sp"
          }`}
          onHide={() => handleCloseDialog("isShowModalListDesign")}
          centered
        >
          <Modal.Body>
            <button
              className="modal_close"
              onClick={() => handleCloseDialog("isShowModalListDesign")}
            >
              <img src="/img/icon_close_new.png" alt="" />
            </button>
            <h3 className="popup_title">
              <img
                className="show_sp"
                src="/img/left_arrow_new2.png"
                onClick={() => handleCloseDialog("isShowModalListDesign")}
              />
              <span>デザイン一覧</span>
            </h3>
            <div className="design_list_wrap scroll_bar_style">
              <ul className="design_list">
                {listDesign.map((item, index) => (
                  <li key={index}>
                    <div className="design_item">
                      <div className="design_img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="design_content">
                        <div className="design_category_type">
                          【{this.handleRenderTypeName(item)}】
                        </div>
                        <div className="design_category_name">{item.name}</div>
                        <div className="design_material">使用素材</div>
                        <p className="design_material_list">
                          {this.handleRenderListMaterial(item)}
                        </p>
                        <div className="design_action">
                          <div className="design_action_btn btn_gray">
                            <button
                              onClick={() =>
                                this.handleToggleDialogDelete(item.id)
                              }
                            >
                              削除する
                            </button>
                          </div>
                          <div className="design_action_btn">
                            <button onClick={() => this.handleEditDesign(item)}>
                              コピーして新規作成
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal confirm delete design */}
        <Modal
          show={isShowDialogConfirmDelete}
          onHide={() => this.setState({ isShowDialogConfirmDelete: false })}
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="dialog_custom"
          centered
        >
          <Modal.Body>
            <span>このデザインを削除しますか？</span>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.handleToggleDialogDelete()}
            >
              {TEXT_CANCEL}
            </Button>
            <Button variant="primary" onClick={() => this.handleDeleteDesign()}>
              削除
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}
